import { defineStore } from 'pinia'
import { readNotifications } from '@directus/sdk'
import { useAuth } from '~/store/auth'

export const useNotifs = defineStore('notifs', () => {
  const notifications = ref([])

  const getNotifications = async () => {
    const _notifications = await useDirectus().client.request(readNotifications({
      filter: {
        recipient: useAuth().user.id
      },
      sort:['-timestamp'],
      fields: ['*']
    }))
    notifications.value = _notifications
  }

  const hasNotif = (suiviId) => {
    return useNotifs().notifications.filter((n) => { return n.suivi_id == suiviId && n.read == false }).length > 0
  }

  return { getNotifications, notifications, hasNotif }
})
